var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{style:({height: '67vh'}),attrs:{"fluid":""}},[_c('h1',{style:({paddingTop: '14%'})},[_vm._v("Page Not Found")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }